import { FormValidations } from "@/utils";

export const BankAccountFormSchema = Object.freeze({
  agency: [FormValidations.IsRequired],
  number: [FormValidations.IsRequired],
  bankId: [FormValidations.IsRequired],
});
